'use client'
import Ranking from '../../../ranquings/page'
import { useTorContext } from 'utils/context'
import { getRandomInt } from 'utils/maths'

const RankingTor = () => {
  const { torDetails } = useTorContext()
  return (
    <Ranking
      rankingFilters={torDetails.filters}
      rankingSelected={
        torDetails.filters[getRandomInt(torDetails.filters.length - 1)]
      }
      categoryHasLocation={torDetails.categoryHasLocation}
    />
  )
}

export default RankingTor
